import { observer } from "mobx-react-lite";
import{ React,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ResultsView from "../views/gameplay/resultsView.jsx";
import { ScoreAlgorithm, calculateRadius } from "../utilities.js";
import FinalResults from "../views/gameplay/finalResultsView.jsx";

const ResultsPresenter = observer(function ResultsRender(props) {
  const navigate = useNavigate();

  const distanceScore = Math.floor(
    ScoreAlgorithm(
      props.model.guessedValues.distance,
      props.model.currentPlanet.distance_light_year
    ) / 2
  );

  const sizeScore = Math.floor(
    ScoreAlgorithm(
      props.model.guessedValues.size,
      calculateRadius(props.model.currentPlanet.radius)
    ) / 2
  );

  const totalScore = distanceScore + sizeScore;

  const handleFinalRoundActions = () => {
    props.model.updateScore(totalScore);
    props.model.saveScoreOnLeaderboard();
  };

  useEffect(() => {
    if (props.model.currentPlanet && props.model.currentRound === 3) {
      handleFinalRoundActions();
    }
  }, [props.model.currentPlanet, props.model.currentRound]); // Only re-run when these change

  function toHomeACB() {
    props.model.resetGame();
    navigate("/");
  }

  function toNextACB() {
    props.model.updateScore(totalScore);
    props.model.addPreviousRound(props.model.currentPlanet, totalScore);
    props.model.nextRound();
    props.model.extractPlanet();
    navigate("/gameplay", { replace: true });
  }

  function toPersonalScoreboardACB() {
    props.model.resetGame();
    navigate("/personalScoreboard", { replace: true });
  }

  function toGeneralScoreboardACB() {
    props.model.resetGame();
    navigate("/generalScoreboard", { replace: true });
  }

  return (
    <div>
      {props.model.currentPlanet ? (
        props.model.currentRound < 3 ? (
          <ResultsView
            score={{
              totalScore: totalScore,
              distanceScore: distanceScore,
              sizeScore: sizeScore,
            }}
            currentRound={props.model.currentRound}
            currentScore={props.model.currentScore.total + totalScore}
            previousScores={props.model.currentScore.previous}
            guessedValues={props.model.guessedValues}
            currentPlanet={props.model.currentPlanet}
            correctSize={calculateRadius(props.model.currentPlanet.radius)}
            correctDistance={props.model.currentPlanet.distance_light_year}
            toNextACB={toNextACB}
          />
        ) : (
          <FinalResults
            score={{
              totalScore: totalScore,
              distanceScore: distanceScore,
              sizeScore: sizeScore,
            }}
            currentRound={props.model.currentRound}
            currentScore={props.model.currentScore.total}
            previousScores={props.model.currentScore.previous}
            guessedValues={props.model.guessedValues}
            currentPlanet={props.model.currentPlanet}
            correctSize={calculateRadius(props.model.currentPlanet.radius)}
            correctDistance={props.model.currentPlanet.distance_light_year}
            toHomeACB={toHomeACB}
            toPersonalScoreboardACB={toPersonalScoreboardACB}
            toGeneralScoreboardACB={toGeneralScoreboardACB}
          ></FinalResults>
        )
      ) : (
        <div>
          An error occurred.{" "}
          <button className="btn-primary" onClick={toHomeACB}>
            Home
          </button>
        </div>
      )}
    </div>
  );
});

export { ResultsPresenter };
